import { BILLING_INDEX, BILLING_GET, BILLING_SHOW } from '../actions/billing'
import apiCall from '../../utils/api'

const state = {
  all: []
}

const getters = {
  [BILLING_INDEX]: (state, getters) => {
    return state.all
  },
  [BILLING_SHOW]: (state, getters) => (id) => {
    return state.all.find((order) => {
      return order.id === parseInt(id)
    })
  }
}

const actions = {
  [BILLING_GET]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/orders', method: 'GET'})
        .then(resp => {
          commit(BILLING_GET, resp.data)
        })
      resolve()
    })
  }
}

const mutations = {
  [BILLING_GET]: (state, resp) => {
    state.all = resp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/billing.js